<div class="card">
    <app-file-upload >
    </app-file-upload> 
</div>
